import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/diginetica/src/lib/scriptDiginetica.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/mindbox/src/lib/MindboxPageView.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/mindbox/src/lib/scriptMindbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageBlogClient"] */ "/app/packages/libs/fo/feature/article/page/blog/src/components/PageBlogClient/PageBlogClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/catalog/base/src/lib/FeatureProductCatalogBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/catalog/base/src/util/parseAsObject.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/search/suggestion/base/src/components/InputSearch/InputSearch.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/search/suggestion/base/src/lib/FeatureSearchSuggestionBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/apps/app-store.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/apps/google-play.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/icons/microphone.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/logos/bioderma.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/logos/esthederm.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/logos/etat-pur.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/logos/naos.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/socials/dzen.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/socials/telegram.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/socials/vk.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/socials/youtube.svg");
;
import(/* webpackMode: "eager", webpackExports: ["GroupLinks"] */ "/app/packages/libs/fo/ui/app/footer/base/src/components/GroupLinks/GroupLinks.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/app/header/base/src/lib/UiAppHeaderBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/app/tapbar/mobile/src/lib/UiAppTapbarMobile.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/article/list/base/src/lib/UiArticleListBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/article/section/important/src/lib/UiArticleSectionImportant.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/doctor/profile/page/src/lib/UiDoctorProfilePage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/section/important-projects/src/lib/UiKitSectionImportantProjects.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/section/seo-text/src/lib/UiKitSectionSeoText.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/mod/footnote/base/src/lib/UiModFootnoteBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/product/layout/catalog/src/lib/UiProductLayoutCatalog.tsx");
